import HeaderForm from "../../../../../components/headerForm";
import quantidade from "../../../../../helpers/QuantidadeFormularios";
import Form from "../../../../../components/form/Form";
import React, {useEffect, useState} from "react";
import Button from "../../../../../components/button/Button";
import ocupacaoApi from "../../../../../services/ocupacaoApi";
import Input from "../../../../../components/input/Input";
import ViaCepService from "../../../../../services/viaCepApi";
import Alert from "../../../../../helpers/Alert";
import processosApi from "../../../../../services/processosApi";
import InputCurrency from "../../../../../components/inputCurrency";

export interface IDadosOcupacao{
    processo?: any;
    setProcesso?: any;
    setTelaNumero?: any;
    telanumero?: any;
    dadosDosPais?: any;
}

export default function DadosOcupacao({processo, setProcesso, setTelaNumero, telanumero, dadosDosPais}: IDadosOcupacao) {
    const [state, setState] = useState({
        id: '',
        processo_id: processo.id,
        ocupacao: '',
        nome_empresa: '',
        cep: '',
        bairro: '',
        endereco: '',
        cidade: '',
        estado: '',
        telefone: '',
        pais: '',
        data_entrada: '',
        salario: '',
        descricao_funcao: '',
    });
    const cepSrv = new ViaCepService();


    useEffect(() => {
        getOcupacao()
    }, [])

    const getOcupacao = async () => {
        const {data, isError} = await ocupacaoApi.one(processo.id);
        if (!isError){
            if (Object.values(data.data).length){
                setState(data.data);
            }
        }
    }

    const handleChange = (value: any, input: string) => {
        setState({...state, [input]: value});
    };
    async function onSubmit() {
        const {data, isError} = state.id ? await ocupacaoApi.update(state.id, state) : await ocupacaoApi.create(state);
        if (isError){
            if (typeof data.data === 'object') {
                Object.keys(data.data.errors).forEach(function(key, index) {
                    Alert.error(data.data.errors[key][0]);
                });
                return;
            }
            return Alert.error(data.data.message? data.data.message : data.data);
        }
        if (!state.id){
            const percent = (telanumero * 100) / quantidade[processo.tipo_visto_id];
            await processosApi.update(processo.id, {percet_conclusao: percent})
            setProcesso({...processo, ['percet_conclusao']: percent})
        }
        Alert.close();
        window.scrollTo(0, 0);
        setTelaNumero(telanumero+1);
    }

    const handleChangeCep = (value: any) => {
        cepSrv.consultaCep(state.cep).then((cepResponse: any) =>{
            if (!cepResponse.data.erro){
                setState({
                    ...state,
                    endereco: cepResponse.data.logradouro,
                    bairro: cepResponse.data.bairro,
                    cidade: cepResponse.data.localidade,
                    estado: cepResponse.data.uf,
                    pais: 'Brasil',
                });
            }
        });
    }
    return(
        <>
            <HeaderForm
                titulo={'Ocupação'}
                numeroPaginalAtual={telanumero}
                numeroTotal={quantidade[processo.tipo_visto_id]}
                percentual={processo.percet_conclusao}
            />
            <Form  onSubmit={() => onSubmit()}>
                <div className={'p-5'}>
                    <div className={'grid md:grid-cols-2 gap-4 mt-5'}>
                        <Input
                            required={true}
                            className={'col-span-1'}
                            label={'Ocupação atual do solicitante'}
                            name={'ocupacao'}
                            setValue={e => handleChange(e, 'ocupacao')}
                            value={state.ocupacao}
                        />
                        <Input
                            required={true}
                            className={'col-span-1'}
                            label={'Nome da empresa ou escola'}
                            name={'nome_empresa'}
                            setValue={e => handleChange(e, 'nome_empresa')}
                            value={state.nome_empresa}
                        />
                    </div>
                    <div className={'grid md:grid-cols-4 gap-4 mt-5'}>
                        <Input
                            className={'md:col-span-1'}
                            label={'CEP'}
                            name={'cep'}

                            setValue={e => handleChange(e, 'cep')}
                            onBlur={(e: any) => handleChangeCep(e)}
                            value={state.cep}
                        />
                        <Input
                            required={true}
                            className={'col-span-2'}
                            label={'Endereço'}
                            name={'endereco'}
                            setValue={e => handleChange(e, 'endereco')}
                            value={state.endereco}
                        />
                        <Input
                            required={true}
                            className={'col-span-1'}
                            label={'Bairro'}
                            name={'bairro'}
                            setValue={e => handleChange(e, 'bairro')}
                            value={state.bairro}
                        />
                    </div>
                    <div className={'grid md:grid-cols-4 gap-4 mt-5'}>
                        <Input
                            required={true}
                            className={'col-span-1'}
                            label={'Cidade'}
                            name={'cidade'}
                            setValue={e => handleChange(e, 'cidade')}
                            value={state.cidade}
                        />
                        <Input
                            required={true}
                            className={'col-span-1'}
                            label={'Estado'}
                            name={'estado'}
                            setValue={e => handleChange(e, 'estado')}
                            value={state.estado}
                        />
                        <Input
                            required={true}
                            className={'col-span-1'}
                            label={'País'}
                            name={'pais'}
                            setValue={e => handleChange(e, 'pais')}
                            value={state.pais}
                        />
                        <Input
                            required={true}
                            className={'col-span-1'}
                            mask={'cellphone'}
                            label={'Telefone'}
                            name={'telefone'}
                            setValue={e => handleChange(e, 'telefone')}
                            value={state.telefone}
                        />
                    </div>
                    <div className={'grid md:grid-cols-5 gap-4 mt-5'}>
                        <Input
                            required={true}
                            className={'md:col-span-2'}
                            type={'date'}
                            label={'Data de admissão no trabalho ou início dos estudos'}
                            name={'data_entrada'}
                            setValue={e => handleChange(e, 'data_entrada')}
                            value={state.data_entrada}
                        />
                        <InputCurrency
                            label={'Renda mensal (em reais)'}
                            className={'col-span-1'}
                            required={true}
                            value={state.salario}
                            onChange={(e: any) => handleChange(e,'salario')}
                            decimalSeparator=","
                            decimalScale={2}
                        />

                        <Input
                            required={true}
                            className={'md:col-span-2'}
                            label={'Descreva brevemente suas funções'}
                            name={'descricao_funcao'}
                            setValue={e => handleChange(e, 'descricao_funcao')}
                            value={state.descricao_funcao}
                        />
                    </div>
                </div>


                <div className={'border-2'}></div>
                <div className={'flex justify-between p-5'}>
                    <Button
                        onClick={() => setTelaNumero(dadosDosPais.parentes_no_pais ? telanumero-1 : telanumero-2)}
                        className={'w-[164px] h-[48px] bg-white text-gray-800 border border-gray-500 font-semibold'}
                    >
                        Voltar
                    </Button>
                    <Button
                        type={'submit'}
                        className={'w-[164px] h-[48px] bg-[#082a60] text-white font-semibold'}
                    >
                        Continuar
                    </Button>
                </div>
            </Form>
        </>
    )
}